import React, { useState } from 'react';


function PrenatalClassesPage (){
    return(
    <div className="container mt-4">
      <h2><i className="bi bi-camera-video me-2"></i>Prenatal Classes</h2>
      <div className="row mt-3 g-3">
        <div className="col-md-6">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">Class Schedule</h5>
              <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between">
                  <span>Week 1: Nutrition Basics</span>
                  <small>Dec 5, 2023</small>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>Week 2: Labor Preparation</span>
                  <small>Dec 12, 2023</small>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}

export default PrenatalClassesPage;
  